<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="toTop"></div>
    <div class="all-header">
      <div class="final-nav">
        <!-- Logo图片居左 -->
        <div class="nav-logo">
          <img
            src="@/components/img/logoCN.png"
            alt="华胤Logo"
            class="logo-img"
            @click="tohome"
          />
        </div>
        <!-- <div class="nav-logos1">
            <span class="nav-logos2" style="color: #a83336">繁中</span>|
            <span class="nav-logos2" @click="toEng">ENG</span>|
            <span class="nav-logos2" @click="toJp">日本語</span>
          </div> -->
        <!-- 桌面导航居右 -->
        <el-menu
          v-if="!isMobile"
          key="desktop"
          class="desktop-nav"
          mode="horizontal"
          @select="handleSelect"
          text-color="#000000"
          active-text-color="#000000"
        >
          <el-menu-item index="home" @click="tohome" class="nav-item">
            <span class="oneItem">首頁</span>
          </el-menu-item>

          <el-submenu index="about" class="nav-item">
            <template slot="title"
              ><span class="oneItem">關於華胤</span></template
            >
            <el-menu-item index="gyhy1" @click="togyhy1">
              <span class="twoItem">歷史沿革</span></el-menu-item
            >
            <el-menu-item index="gyhy2" @click="togyhy2"
              ><span class="twoItem">華胤目標</span></el-menu-item
            >
            <el-menu-item index="gyhy3" @click="togyhy3"
              ><span class="twoItem">華胤願景</span></el-menu-item
            >
            <el-menu-item index="gyhy4" @click="togyhy4"
              ><span class="twoItem">ESG</span></el-menu-item
            >
            <el-menu-item index="gyhy5" @click="togyhy5"
              ><span class="twoItem">工廠介紹</span></el-menu-item
            >
            <el-menu-item index="gyhy6" @click="togyhy6"
              ><span class="twoItem">國際認證與建築獎項</span></el-menu-item
            >
          </el-submenu>

          <el-submenu index="product" class="nav-item">
            <template slot="title"
              ><span class="oneItem">技術與產品</span></template
            >
            <el-menu-item index="cpyfw1" @click="tocpyfw1"
              ><span class="twoItem">工程設計</span></el-menu-item
            >
            <el-menu-item index="cpyfw2" @click="tocpyfw2"
              ><span class="twoItem">系統產品</span></el-menu-item
            >
            <el-menu-item index="cpyfw3" @click="tocpyfw3"
              ><span class="twoItem">華胤專利</span></el-menu-item
            >
            <el-menu-item index="cpyfw4" @click="tocpyfw4"
              ><span class="twoItem">安裝服務</span></el-menu-item
            >
            <el-menu-item index="cpyfw5" @click="tocpyfw5"
              ><span class="twoItem">國盛新能源</span></el-menu-item
            >
          </el-submenu>

          <el-submenu index="quality" class="nav-item">
            <template slot="title"
              ><span class="oneItem">品質與安全</span></template
            >
            <el-menu-item index="pzyaq1" @click="topzyaq1"
              ><span class="twoItem">品質管理</span></el-menu-item
            >
            <el-menu-item index="pzyaq2" @click="topzyaq2"
              ><span class="twoItem">產品質量</span></el-menu-item
            >
            <el-menu-item index="pzyaq3" @click="topzyaq3"
              ><span class="twoItem">產品包裝</span></el-menu-item
            >
            <el-menu-item index="pzyaq4" @click="topzyaq4"
              ><span class="twoItem">職業安全政策</span></el-menu-item
            >
          </el-submenu>
          <el-menu-item index="gcjs" @click="togcyj" class="nav-item"
            ><span class="oneItem">工程實績</span></el-menu-item
          >
          <el-menu-item index="news" @click="tozxxx" class="nav-item"
            ><span class="oneItem">最新消息</span></el-menu-item
          >
          <!-- <el-menu-item index="language" @click="changeLan" class="language-item">
          <i class="glyphicon glyphicon-globe"></i>
          <span class="oneItem" @click="changeLan()">EN</span>
        </el-menu-item> -->
          <el-submenu index="language" class="nav-item">
            <template slot="title"><span class="oneItem">語言</span></template>
            <el-menu-item index="english" @click="toEng"
              ><span class="twoItem">英語</span></el-menu-item
            >
            <el-menu-item index="japan" @click="toJp"
              ><span class="twoItem">日語</span></el-menu-item
            >
          </el-submenu>
        </el-menu>

        <!-- 移动端菜单按钮 -->
        <div class="mobile-nav" v-if="isMobile">
          <div class="hamburger-btn" @click="openMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <el-drawer
            :visible.sync="drawerVisible"
            direction="ltr"
            size="75%"
            :modal="true"
            :modal-append-to-body="false"
            custom-class="optimized-drawer"
            @open="lockBodyScroll"
            @close="unlockBodyScroll"
            :with-header="false"
          >
            <el-menu
              class="mobile-menu"
              :default-active="activeIndex"
              @select="handleSelect"
            >
              <el-menu-item index="home" @click="tohome" class="mobile-item">
                <i class="el-icon-house"></i>
                <span class="oneItem" index="/home">首頁</span>
              </el-menu-item>

              <el-submenu index="about" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem" index="/gyhy">關於華胤</span>
                </template>
                <el-menu-item index="gyhy1" @click="togyhy1"
                  ><span class="twoItem">歷史沿革</span></el-menu-item
                >
                <el-menu-item index="gyhy2" @click="togyhy2"
                  ><span class="twoItem">華胤目標</span></el-menu-item
                >
                <el-menu-item index="gyhy3" @click="togyhy3"
                  ><span class="twoItem">華胤願景</span></el-menu-item
                >
                <el-menu-item index="gyhy4" @click="togyhy4"
                  ><span class="twoItem">ESG</span></el-menu-item
                >
                <el-menu-item index="gyhy5" @click="togyhy5"
                  ><span class="twoItem">工廠介紹</span></el-menu-item
                >
                <el-menu-item index="gyhy6" @click="togyhy6"
                  ><span class="twoItem">國際認證與建築獎項</span></el-menu-item
                >
              </el-submenu>

              <el-submenu index="cpyfw" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem" index="/cpyfw">技術與產品</span>
                </template>
                <el-menu-item index="cpyfw1" @click="tocpyfw1"
                  ><span class="twoItem">工程設計</span></el-menu-item
                >
                <el-menu-item index="cpyfw2" @click="tocpyfw2"
                  ><span class="twoItem">系統產品</span></el-menu-item
                >
                <el-menu-item index="cpyfw3" @click="tocpyfw3"
                  ><span class="twoItem">華胤專利</span></el-menu-item
                >
                <el-menu-item index="cpyfw4" @click="tocpyfw4"
                  ><span class="twoItem">安裝服務</span></el-menu-item
                >
                <el-menu-item index="cpyfw5" @click="tocpyfw5"
                  ><span class="twoItem">國盛新能源</span></el-menu-item
                >
              </el-submenu>

              <el-submenu index="pzyaq" class="mobile-item">
                <template slot="title">
                  <i class="el-icon-menu"></i>
                  <span class="oneItem" index="/pzyaq">品質與安全</span>
                </template>
                <el-menu-item index="pzyaq1" @click="topzyaq1"
                  ><span class="twoItem">品質管理</span></el-menu-item
                >
                <el-menu-item index="pzyaq2" @click="topzyaq2"
                  ><span class="twoItem">產品質量</span></el-menu-item
                >
                <el-menu-item index="pzyaq3" @click="topzyaq3"
                  ><span class="twoItem">產品包裝</span></el-menu-item
                >
                <el-menu-item index="pzyaq4" @click="topzyaq4"
                  ><span class="twoItem">職業安全政策</span></el-menu-item
                >
              </el-submenu>

              <el-menu-item index="gcyj" @click="togcyj" class="mobile-item">
                <i class="el-icon-notebook-2"></i>
                <span class="oneItem" index="/gcyj">工程實績</span>
              </el-menu-item>

              <el-menu-item index="zxxx" @click="tozxxx" class="mobile-item">
                <i class="el-icon-news"></i>
                <span class="oneItem" index="/zxxx">最新消息</span>
              </el-menu-item>

              <el-submenu index="language" class="mobile-item">
                <template slot="title">
                  <img
                    src="@/components/img/diqiu.png"
                    style="width: 20px; height: 20px; margin-right: 10px"
                  />
                  <span class="oneItem" index="/language">語言</span>
                </template>
                <el-menu-item index="language1" @click="toEng"
                  ><span class="twoItem">English</span></el-menu-item
                >
                <el-menu-item index="language2" @click="toJp"
                  ><span class="twoItem">日本語</span></el-menu-item
                >
              </el-submenu>

              <!-- <el-menu-item index="language" @click="changeLan" class="mobile-item">
              <i class="el-icon-sort"></i>
              <span class="oneItem">EN</span>
            </el-menu-item> -->

              <el-menu-item
                index="close"
                @click="drawerVisible = false"
                class="close-item"
              >
                <i class="el-icon-close"></i>
                <span class="oneItem">關閉</span>
              </el-menu-item>
            </el-menu>
          </el-drawer>
        </div>
      </div>
    </div>
    <Loader v-if="isLoading" />
  </div>
</template>

<script>
import Loader from '../skip/Loader.vue'
export default {
  props: {
    Language: String,
  },
  data() {
    return {
      isLoading: false,
      activeIndex: 'home',
      isMobile: false,
      drawerVisible: false,
      resizeTimer: null,
    }
  },
  methods: {
    changeLan() {
      this.$emit('ELchange')
    },
    toEng() {
      this.$emit('ELchange')
    },
    toJp() {
      this.$emit('JLchange')
    },
    handleSelect(index) {
      if (index === 'close') return
      this.activeIndex = index
      if (this.isMobile) {
        this.drawerVisible = false
      }
    },
    checkMobile() {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        const wasMobile = this.isMobile
        this.isMobile = window.innerWidth < 1400

        if (wasMobile && !this.isMobile) {
          this.drawerVisible = false
        }
      }, 200)
    },
    // 首頁
    tohome() {
      if (this.$route.fullPath != '/home') {
        this.isLoading = true
        this.$router
          .push('/home')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 關於華胤
    togyhy1() {
      if (this.$route.fullPath != '/gyhy') {
        this.isLoading = true
        this.$router
          .push('/gyhy')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhy2() {
      if (this.$route.fullPath != '/gyhy#hymb') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhy',
            hash: '#hymb',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhy3() {
      if (this.$route.fullPath != '/gyhy#hyyj') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhy',
            hash: '#hyyj',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhy4() {
      if (this.$route.fullPath != '/gyhy#esg') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhy',
            hash: '#esg',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhy5() {
      if (this.$route.fullPath != '/gyhy#gcjs') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhy',
            hash: '#gcjs',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    togyhy6() {
      if (this.$route.fullPath != '/gyhy#rzjx') {
        this.isLoading = true
        this.$router
          .push({
            path: '/gyhy',
            hash: '#rzjx',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 产品与服务
    tocpyfw1() {
      if (this.$route.fullPath != '/cpyfw') {
        this.isLoading = true
        this.$router
          .push('/cpyfw')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfw2() {
      if (this.$route.fullPath != '/cpyfw#xtcp') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfw',
            hash: '#xtcp',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfw3() {
      if (this.$route.fullPath != '/cpyfw#hyzl') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfw',
            hash: '#hyzl',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfw4() {
      if (this.$route.fullPath != '/cpyfw#azfw') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfw',
            hash: '#azfw',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    tocpyfw5() {
      if (this.$route.fullPath != '/cpyfw#gsxny') {
        this.isLoading = true
        this.$router
          .push({
            path: '/cpyfw',
            hash: '#gsxny',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 品质与安全
    topzyaq1() {
      if (this.$route.fullPath != '/pzyaq') {
        this.isLoading = true
        this.$router
          .push('/pzyaq')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaq2() {
      if (this.$route.fullPath != '/pzyaq#cpzl') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaq',
            hash: '#cpzl',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaq3() {
      if (this.$route.fullPath != '/pzyaq#cpbz') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaq',
            hash: '#cpbz',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    topzyaq4() {
      if (this.$route.fullPath != '/pzyaq#aqzc') {
        this.isLoading = true
        this.$router
          .push({
            path: '/pzyaq',
            hash: '#aqzc',
          })
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 工程业绩
    togcyj() {
      if (this.$route.fullPath != '/gcyj') {
        this.isLoading = true
        this.$router
          .push('/gcyj')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },
    // 最新消息
    tozxxx() {
      if (this.$route.fullPath != '/zxxx') {
        this.isLoading = true
        this.$router
          .push('/zxxx')
          .then(() => {
            location.reload()
          })
          .finally(() => {
            window.addEventListener('load', () => {
              this.isLoading = false
            })
          })
      }
    },

    openMobileMenu() {
      this.drawerVisible = true
    },
    lockBodyScroll() {
      document.body.classList.add('mobile-nav-open')
      document.addEventListener('wheel', this.preventScroll, { passive: false })
    },
    unlockBodyScroll() {
      document.body.classList.remove('mobile-nav-open')
      document.removeEventListener('wheel', this.preventScroll)
    },
    preventScroll(e) {
      if (this.drawerVisible) {
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
    clearTimeout(this.resizeTimer)
  },
  components: {
    Loader,
  },
}
</script>

<style scoped>
.toTop {
  width: 100%;
  height: 80px;
}
.all-header {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100vw;
  max-width: 100vw;
  background-color: #fff;
  border-bottom: 1px solid #8b8b8b;
}
.final-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 84px;
  position: relative;
  z-index: 1000;
  width: 95vw;
  margin: 0 auto;
}

.nav-logo {
  display: flex;
  align-items: center;
}

.nav-logos {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.nav-logos1 {
  display: flex;
  background-color: #f2f2f2;
  height: 30px;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  color: #808080;
  font-weight: bolder;
  padding: 0 10px;
  border-radius: 15px;
  margin-right: 15px;
}
.nav-logos2 {
  margin: 0 10px;
}

.logo-img {
  height: 75px;
  width: auto;
}

.desktop-nav {
  border-bottom: none;
  display: flex;
  align-items: center;
  height: 80px;
}

/* 桌面版菜单项与分割线 */
.nav-item {
  position: relative;
  padding: 0 20px;
}
.nav-item:not(:last-child):after {
  content: '';
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 16px;
  width: 1px;
  background-color: #e6e6e6;
}

.language-item i {
  margin-right: 5px;
}

/* 移动端三横线按钮 */
.hamburger-btn {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 20px;
  height: 14px;
  cursor: pointer;
}
.hamburger-btn span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #333;
  transition: all 0.3s;
}

/* 移动端菜单样式 */
.optimized-drawer {
  pointer-events: none;
}

.optimized-drawer .el-drawer__container {
  pointer-events: auto;
}

.optimized-drawer .el-drawer__mask {
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.3);
}
.mobile-menu {
  border-right: none;
  padding-top: 10px;
}

/* 移动端菜单项与分割线 */
.mobile-item {
  border-bottom: 1px solid #f5f5f5;
}
.mobile-item:last-child {
  border-bottom: none;
}

.close-item {
  margin-top: 10px;
  border-top: 1px solid #e6e6e6;
}

.oneItem {
  font-size: 20px;
  font-weight: bolder;
}
.twoItem {
  font-size: 16px;
  font-weight: 400;
  margin: 10px 0;
}
div /deep/ .el-submenu__title {
  padding: 0;
}

/* 响应式断点 */
@media (max-width: 1400px) {
  .toTop {
    width: 100%;
    height: 80px;
  }
  .desktop-nav {
    display: none;
  }
  .mobile-nav {
    display: block;
  }
  .final-nav {
    height: 80px;
    width: 98vw;
    padding: 0 15px 0 5px;
  }
  .logo-img {
    height: 60px;
  }
  .oneItem {
    font-size: 17px;
    font-weight: normal;
  }
  .twoItem {
    font-size: 16px;
    font-weight: normal;
  }
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 19px;
    cursor: pointer;
  }
}

/* 响应式调整 */
@media (max-width: 1400px) {
  .el-menu-item:hover {
    background: var(--hover-bg-color) !important;
  }
}

/* 响应式断点 */
@media (max-width: 767px) {
  .toTop {
    width: 100%;
    height: 56px;
  }
  .desktop-nav {
    display: none;
  }
  .mobile-nav {
    display: block;
  }
  .final-nav {
    height: 56px;
    width: 100vw;
    padding: 0 15px 0 5px;
  }
  .logo-img {
    height: 42px;
  }
  .oneItem {
    font-size: 14px;
    font-weight: normal;
  }
  .twoItem {
    font-size: 13px;
    font-weight: normal;
  }
  .hamburger-btn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 20px;
    height: 14px;
    cursor: pointer;
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .el-menu-item:hover {
    background: var(--hover-bg-color) !important;
  }
}

.el-menu--horizontal .el-menu--popup {
  padding: 5px 0;
}
.el-menu--horizontal .el-menu--popup .el-menu-item {
  height: 40px;
  line-height: 40px;
  transition: all 0.2s;
  border-top: 1px solid #f5f5f5;
}
.el-menu--horizontal .el-menu--popup .el-menu-item:first-child {
  border-top: 6px solid #404040;
}

.el-menu--horizontal .el-menu--popup .el-menu-item:hover {
  background: rgb(96, 96, 96);
}
.el-menu--horizontal .el-menu--popup .el-menu-item:hover .twoItem {
  color: #fff;
  transform: translateX(3px);
}

/* 移动版 */
.mobile-menu .el-menu-item {
  transition: all 0.3s;
}
.mobile-menu .el-menu-item:hover {
  background: var(--hover-bg-color);
}
.mobile-menu .el-menu-item:hover .twoItem {
  color: green;
}

@media (min-width: 1400px) {
  .mobile-nav {
    display: none;
  }
}
@media (min-width: 2000px) {
  .oneItem {
    font-size: 25px;
  }
  .twoItem {
    font-size: 19px;
  }
  .logo-img {
    height: 80px;
  }
  .el-menu--horizontal .el-menu--popup .el-menu-item {
    height: 50px;
    line-height: 50px;
  }
}
</style>
